
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { useUserRole } from './useUserRole';

export const useDashboardStats = () => {
  const { user } = useAuth();
  const { data: userRole } = useUserRole();

  return useQuery({
    queryKey: ['dashboard-stats', user?.id, userRole],
    queryFn: async () => {
      if (!user?.id) return null;

      console.log('Fetching dashboard stats for user:', user.id, 'with role:', userRole);

      // With clean RLS policies, we can query directly with count
      // The organization-based policies will automatically filter the results
      const [candidatesResult, jobsResult, interviewsResult, placementsResult] = await Promise.all([
        supabase
          .from('candidates')
          .select('*', { count: 'exact', head: true }),

        supabase
          .from('jobs')
          .select('*', { count: 'exact', head: true }),

        supabase
          .from('calendar_events')
          .select('*', { count: 'exact', head: true })
          .gte('start_time', new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString())
          .lte('start_time', new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0, 23, 59, 59).toISOString()),

        supabase
          .from('candidates')
          .select('*', { count: 'exact', head: true })
          .not('accepted_date', 'is', null),
      ]);

      const stats = {
        candidates: candidatesResult.count || 0,
        jobs: jobsResult.count || 0,
        interviews: interviewsResult.count || 0,
        placements: placementsResult.count || 0,
      };

      console.log('Dashboard stats fetched:', stats, 'for role:', userRole);
      return stats;
    },
    enabled: !!user?.id && userRole !== undefined,
    staleTime: 30 * 1000, // 30 seconds
  });
};
